import { useState } from "react";
import { useReducedMotion } from "framer-motion";

const TEXT = { false: "gap-5 pr-5 text-lg text-ink/70", true: "gap-4 pr-4 text-[15px] text-ink/85" };

const items = (names, compact) =>
  names.map((p) => (
    <li key={p} className={`flex shrink-0 items-center whitespace-nowrap font-display italic ${TEXT[compact]}`}>
      {p}
      {!compact && <span aria-hidden className="h-1 w-1 rounded-full bg-ink/25" />}
    </li>
  ));

export default function PressMarquee({ names, label = "As seen on", compact = false }) {
  const reduce = useReducedMotion();
  const [paused, setPaused] = useState(false);

  if (reduce)
    return (
      <ul className={`flex flex-wrap gap-y-2 ${compact ? "justify-center gap-x-4" : "gap-x-5"}`} aria-label={label} data-testid="press-list-static">
        {names.map((p, i) => (
          <li key={p} className={`flex items-center font-display italic ${compact ? "gap-4 text-[15px] text-ink/85" : "gap-5 text-lg text-ink/70"}`}>
            {p}
            {i < names.length - 1 && <span aria-hidden className={`h-1 w-1 rounded-full ${compact ? "bg-ink/20" : "bg-ink/25"}`} />}
          </li>
        ))}
      </ul>
    );

  return (
    <div
      tabIndex={0}
      role="region"
      aria-label={`${label} (scrolling list, hover or focus to pause)`}
      data-paused={paused}
      data-testid="press-marquee"
      onTouchStart={() => setPaused(true)}
      onTouchEnd={() => setPaused(false)}
      onTouchCancel={() => setPaused(false)}
      className="press-marquee relative min-w-0 flex-1 overflow-hidden rounded-sm py-1 [-webkit-mask-image:linear-gradient(to_right,transparent,#000_8%,#000_92%,transparent)] [mask-image:linear-gradient(to_right,transparent,#000_8%,#000_92%,transparent)]"
    >
      <div className="press-track flex w-max" style={{ animationDuration: `${names.length * 4.5}s` }} data-testid="press-track">
        <ul aria-label={label} className="flex shrink-0 items-center">
          {items(names, compact)}
        </ul>
        <ul aria-hidden="true" className="flex shrink-0 items-center" data-testid="press-track-duplicate">
          {items(names, compact)}
        </ul>
      </div>
    </div>
  );
}
